export enum ModuleType {
  PROFILEPIC = 'PROFILEPIC'
}
